/**
 * Cor da bolinha de status.
 *
 * A cor vem daqui e não de `cn_order_statuses.color` porque 45 dos 63 status do banco
 * usam o mesmo azul (#4380E6) — inclusive "Entregue". Usar a cor do banco deixaria a
 * coluna inteira azul e o status perderia leitura visual.
 */
export type StatusTone = 'done' | 'progress' | 'waiting' | 'error' | 'closed'

export const TONE_COLOR: Record<StatusTone, string> = {
  done: '#268564',
  progress: '#4380E6',
  waiting: '#F0780A',
  error: '#DA1E28',
  closed: '#646464'
}

/** Status que exigem ação do paciente ou do time. */
const ERROR_STATUSES = [
  'reversed',
  'refund_request',
  'lost',
  'returning_origin',
  'damaged_package',
  'not_delivered',
  'delivery_attempt',
  'problems_with_delivery',
  'package_held',
  'package_retained',
  'anvisa_exception',
  'disapproved_document',
  'Irregular_CPF',
  'carrier_needs_information',
  'payment_refused'
]

/** Pedido parado, esperando algo acontecer. */
const WAITING_STATUSES = [
  'waiting_payment',
  'awaiting_payment',
  'waiting_documentation',
  'waiting_approval',
  'under_review',
  'conference',
  'waiting_stock',
  'waiting_separation',
  'waiting_trace_generation',
  'shipping_supplier',
  'waiting_anvisa',
  'delay_release',
  'federal_revenue',
  'federal_revenue_analysis',
  'problems_with_customs'
]

export const getStatusTone = (status?: string | null): StatusTone => {
  if (!status) return 'progress'
  if (status === 'delivered') return 'done'
  if (status === 'canceled') return 'closed'
  if (ERROR_STATUSES.includes(status)) return 'error'
  if (WAITING_STATUSES.includes(status)) return 'waiting'
  return 'progress'
}

export const getStatusColor = (status?: string | null): string => TONE_COLOR[getStatusTone(status)]
